export const text = {
    notificationNote:"Note : Please Don't Replace Variable Between # Sign.",
    notificationPurpose:"Notification Purpose",
    notificationMessage:"Notification Message",
    noteImage:"[Note: Recommended dimension for banner image is 2880 * 1620.]",
    addBanner: 'Add Banner',
};
